<template>
  <div class="search-result">
    <template v-if="!emptyResult">
      <ym-search-block v-for="(block, index) in result"
                       :key="index"
                       :q="q"
                       :type="type"
                       :block="block"
      />
    </template>
    <div v-else
         class="empty-search-result"
    >
      暂未找到搜索结果，试试别的关键词吧
    </div>
  </div>
</template>

<script>
  import SearchBlock from '@/pages/Search/components/SearchResultBlock';

  export default {
    name: 'SearchResult',
    components: {
      'ym-search-block': SearchBlock,
    },
    props: {
      q: {
        type: String,
        required: true,
      },
      type: {
        type: String,
        required: true,
      },
      result: {
        type: Array,
        required: true,
        default() {
          return [];
        },
      },
    },
    computed: {
      emptyResult() {
        const { result } = this;
        const { length } = result;
        return length === 0;
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .empty-search-result {
    padding: @size-large 0;
    text-align: center;
    color: @color-text-lighter;
  }
</style>
